<template>
  <div class="bg-background-neutral-secondary space-y-3 rounded-2xl p-4">
    <h4 class="text-text-neutral-primary text-lg font-semibold">
      {{ $t('general.passengers') }}
    </h4>
    <div
      v-for="(passenger, idx) in mappedPassengers"
      :key="idx"
      class="flex items-center space-x-3"
    >
      <PassengerInfoButton
        :passenger="passenger"
        :with-click-animation="false"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { PassengerInfoButton } from 'freedom-shared';
  import type { Airflow } from '@aviata/platform-types';

  const props = defineProps<{
    passengers: Airflow.Booking.Passenger[];
  }>();

  const mappedPassengers = computed(() => {
    return (
      props.passengers
        /* eslint-disable camelcase */
        .map(({ document, first_name, last_name }) => ({
          last_name,
          first_name,
          document_type: document.type,
          document_number: document.number,
          /* eslint-enable camelcase */
        }))
    );
  });
</script>
